import { render, staticRenderFns } from "./MedicationSafety.vue?vue&type=template&id=722d2e09&scoped=true"
import script from "./MedicationSafety.vue?vue&type=script&lang=js"
export * from "./MedicationSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d2e09",
  null
  
)

export default component.exports